import React from "react";
import { PRICE_MODE_OPTIONS, RETAILER_OPTIONS, priceModeChipClass } from "../utils/catalogFilters";

const FILTER_LABEL_CLASS = "font-semibold text-[#24303A] text-[18px] mb-2";

function FilterChip({ active, label, onClick }) {
  return (
    <button type="button" onClick={onClick} className={priceModeChipClass(active)}>
      {label}
    </button>
  );
}

export default function RetailerPriceModeFilters({
  retailer,
  priceMode,
  onRetailerChange,
  onPriceModeChange,
  className = "",
}) {
  return (
    <div className={`space-y-3 ${className}`.trim()}>
      <div>
        <h2 className={FILTER_LABEL_CLASS}>Retailer</h2>
        <div className="flex min-w-0 gap-2 overflow-x-auto overscroll-x-contain pb-1 [-webkit-overflow-scrolling:touch]">
          {RETAILER_OPTIONS.map((option) => (
            <FilterChip
              key={option.id}
              label={option.label}
              active={retailer === option.id}
              onClick={() => onRetailerChange(option.id)}
            />
          ))}
        </div>
      </div>

      <div>
        <h2 className={FILTER_LABEL_CLASS}>Price Mode</h2>
        <div className="flex flex-wrap gap-2">
          {PRICE_MODE_OPTIONS.map((option) => (
            <FilterChip
              key={option.id}
              label={option.label}
              active={priceMode === option.id}
              onClick={() => onPriceModeChange(option.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
